module.exports = __webpack_public_path__ + "static/machine-ba0b937e73f0eed7f82b6a2b7f488b14.jpg";